/* tslint:disable */

declare var Object: any;
export interface SfPayrollWizardInterface {
  "id"?: number;
}

export class SfPayrollWizard implements SfPayrollWizardInterface {
  "id": number;
  constructor(data?: SfPayrollWizardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SfPayrollWizard`.
   */
  public static getModelName() {
    return "SfPayrollWizard";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SfPayrollWizard for dynamic purposes.
  **/
  public static factory(data: SfPayrollWizardInterface): SfPayrollWizard{
    return new SfPayrollWizard(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SfPayrollWizard',
      plural: 'sfPayrollWizard',
      path: 'sfPayrollWizard',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SfPayrollWizard.ts